import styled from 'styled-components'

const StyledModalConfirmacaoExecucaoIntegracao = styled.div`

  .aviso-proxima-execucao {
    margin-top: 8px;
    margin-bottom: 12px;
    padding: 10px 14px;
    background-color: #fff8e1;
    border-left: 4px solid #fbba49;
    border-radius: 4px;
    font-size: 13px;
    color: #7a5c00;
    line-height: 1.5;
  }

  .mensagem-modal-integracao-mensagem {
    margin-top: 10px;
    margin-bottom: 28px;
    font-weight: var(--font-weight-semibold);
    color: var(--color-feedback-danger-600);
    font-size: 14px;
    text-align: left;
  }

  .botoes-modal-integracao {
    display: flex;
    justify-content: flex-end;
  }

  .divisor-modal-integracao {
    width: 100%;
    height: 1px;
    background-color: #ebecec;
    margin-bottom: 20px;
}
`

export default StyledModalConfirmacaoExecucaoIntegracao
